<template>
	<div :id="id" :class="`${right ? 'right-0' : ''} absolute z-50 hidden flex-col border rounded-lg bg-white dark:bg-slate-800 dark:border-slate-800 mt-3 p-2 gap-2 shadow-lg dark:shadow-none max-h-72 overflow-y-auto dropdown-list`" @click.stop="">
		<slot/>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'

defineProps({
	id: {
		type: String,
		required: true,
	},
	right: Boolean,
})
</script>
